import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

import style from '@components/Filters/style/Filters.module.scss';

const RangeSlider = ({
  title = '',
  ariaLabel = 'Range',
  value = [],
  marks = false,
  rangeUnit = '%',
  handleChange = () => {},
  disabled,
  groupName = '',
  options = { minPrice: 0, maxPrice: 100 }
}) => {
  const minPrice = options.minPrice;
  const maxPrice = options.maxPrice;

  const [openAccordion, setOpenAccordion] = useState(false);

  const rangeValuetext = (value) => {
    return `${value}${rangeUnit}`;
  };

  return (
    <Box data-testid={`RangeSlider-${groupName}`} sx={{ mb: 1 }}>
      <Accordion
        expanded={openAccordion}
        onChange={() => !disabled && setOpenAccordion((prevState) => !prevState)}
        data-testid={`accordionRangeGroup-${groupName}`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`accordionRangeContent-${groupName}`}
          id={`accordionRangeTitle-${groupName}`}
        >
          <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} className={style.rangeSliderForm}>
            <Grid item xs={12}>
              <Slider
                getAriaLabel={() => ariaLabel}
                marks={marks}
                step={1}
                min={minPrice && minPrice === maxPrice ? 0 : minPrice}
                max={maxPrice}
                value={value}
                onChange={(e) => {
                  e.target.type = 'slider';
                  handleChange(e, groupName);
                }}
                valueLabelDisplay='auto'
                getAriaValueText={rangeValuetext}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography gutterBottom className={style.rangeSliderTypography}>
                {ariaLabel}: {value[0]} - {value[1]} {rangeUnit}
              </Typography>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default RangeSlider;
